type BarrierWaiter = {
  nodeId: string;
  blockingRunIds: readonly string[];
};

/**
 * The runs still holding a workflow at a barrier, for the event that parked it
 * there: only a pending barrier node, and never a superseded (soft-deleted)
 * event. Anything else has nothing to link to.
 */
export const getBlockingRunIds = (
  event: { type: string; nodeId?: string | null; deletedAt?: string | null },
  barrierWaiters: readonly BarrierWaiter[],
): readonly string[] => {
  const eventType = event.type.split(":")[1] || event.type;
  const isParkedBarrier =
    eventType === "pending" &&
    !!event.nodeId &&
    event.nodeId.startsWith("barrier:") &&
    !event.deletedAt;

  if (!isParkedBarrier) return [];

  return (
    barrierWaiters.find((waiter) => waiter.nodeId === event.nodeId)
      ?.blockingRunIds ?? []
  );
};
